import {
  HIDE_MAP_INFO_BUBBLE,
  SHOW_MAP_INFO_BUBBLE,
  SWITCH_TAB, SWITCH_VIEW,
  TOGGLE_ALERT,
  SHOW_OVERLAY_FILTERS,
  HIDE_OVERLAY_FILTERS
} from '../actions/ui';

export default function (state = {}, action) {
  switch (action.type) {
  case HIDE_MAP_INFO_BUBBLE:
    return { ...state, activeMapComp: null, showMapInfoWindow: false };
  case SHOW_MAP_INFO_BUBBLE:
    if (state.currentTab === 'lease') {
      return { ...state, activeMapComp: action.leases, showMapInfoWindow: true };
    } else {
      return { ...state, activeMapComp: action.sales, showMapInfoWindow: true };
    }
  case SWITCH_TAB:
    return { ...state, currentTab: action.tab };
  case SWITCH_VIEW:
    return { ...state, currentView: action.view };
  case TOGGLE_ALERT:
    return { ...state, alertMessage: action.message, error: action.error };
  case SHOW_OVERLAY_FILTERS:
    return { ...state, showColumnFilters: true };
  case HIDE_OVERLAY_FILTERS:
    return { ...state, showColumnFilters: false };  
  default:
    return state;
  }
}
